import { render, staticRenderFns } from "./CustomerCommercial.vue?vue&type=template&id=1bb40f1a&scoped=true"
import script from "./CustomerCommercial.vue?vue&type=script&lang=js"
export * from "./CustomerCommercial.vue?vue&type=script&lang=js"
import style0 from "./CustomerCommercial.vue?vue&type=style&index=0&id=1bb40f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb40f1a",
  null
  
)

export default component.exports